var _g, _path, _path2, _line, _line2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadyStocknew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 71,
    viewBox: "0 0 44 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_14796_16208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 1H6C5.44772 1 5 1.44772 5 2V51.5436C5 52.2455 5.70418 52.729 6.35922 52.4768L38.3592 40.1598C38.7453 40.0112 39 39.6402 39 39.2265V2C39 1.44772 38.5523 1 38 1Z",
    fill: "url(#paint0_linear_14796_16208)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63855 16.8098L10.7936 16.2781C11.5429 16.0932 12.1328 16.1347 12.5636 16.4025C12.9921 16.6614 13.2956 17.1522 13.4739 17.875L13.6142 18.4435C13.8512 19.4043 13.684 20.0908 13.1124 20.503L13.1189 20.5294C13.4976 20.5482 13.7977 20.7032 14.0192 20.9946C14.2495 21.2837 14.4321 21.7016 14.5669 22.248L14.9681 23.8743C15.0334 24.1387 15.0955 24.3525 15.1544 24.5156C15.2112 24.6699 15.2944 24.8177 15.4041 24.9589L13.9233 25.3243C13.8334 25.1875 13.7634 25.0552 13.7131 24.9273C13.6629 24.7994 13.5953 24.5636 13.5105 24.2199L13.093 22.5275C12.9886 22.1045 12.8452 21.8266 12.6629 21.6939C12.4893 21.5591 12.2351 21.5329 11.9002 21.6156L11.3977 21.7395L12.3764 25.706L10.922 26.0648L8.63855 16.8098ZM11.6004 20.2869C11.8913 20.2152 12.0887 20.087 12.1928 19.9023C12.3057 19.7155 12.3186 19.4458 12.2316 19.0932L12.0555 18.3793C11.9728 18.0443 11.8513 17.8172 11.6909 17.6978C11.5394 17.5762 11.3358 17.547 11.0802 17.61L10.4191 17.7731L11.0715 20.4174L11.6004 20.2869ZM13.971 15.4941L17.9374 14.5155L18.2636 15.8377L15.7516 16.4575L16.3551 18.9034L18.3515 18.4108L18.6777 19.733L16.6813 20.2256L17.3826 23.0682L19.8947 22.4484L20.2209 23.7705L16.2545 24.7491L13.971 15.4941ZM19.8979 14.0318L21.8679 13.5458L25.6586 22.4289L24.2043 22.7877L23.4864 21.0152L23.4929 21.0416L21.8402 21.4494L22.0227 23.3259L20.6741 23.6587L19.8979 14.0318ZM23.0111 19.828L21.2346 15.4132L21.2082 15.4197L21.7022 20.1509L23.0111 19.828ZM24.0807 12.9998L26.3019 12.4518C27.0247 12.2734 27.6146 12.3336 28.0717 12.6323C28.5288 12.9309 28.8497 13.4549 29.0346 14.2041L30.1894 18.8845C30.3742 19.6337 30.3338 20.2468 30.0681 20.7238C29.8024 21.2007 29.3082 21.5284 28.5854 21.7067L26.3642 22.2548L24.0807 12.9998ZM28.2327 20.3911C28.4707 20.3324 28.634 20.2173 28.7226 20.0458C28.82 19.8722 28.8296 19.6267 28.7513 19.3094L27.5639 14.4968C27.4856 14.1795 27.363 13.9666 27.196 13.8582C27.0378 13.7476 26.8397 13.7217 26.6017 13.7804L25.8613 13.9631L27.4923 20.5738L28.2327 20.3911ZM31.8662 16.7174L28.7964 11.8363L30.3433 11.4546L32.1733 14.6079L32.1997 14.6013L32.353 10.9588L33.7677 10.6097L33.3206 16.3586L34.2927 20.2986L32.8383 20.6574L31.8662 16.7174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9967 37.7735C12.2916 37.9475 11.7094 37.8807 11.2501 37.5732C10.7887 37.2569 10.4656 36.7242 10.2807 35.975L10.1502 35.4461L11.5252 35.1069L11.6818 35.7415C11.8297 36.3409 12.1548 36.5786 12.6573 36.4546C12.9041 36.3937 13.0718 36.2775 13.1604 36.106C13.2556 35.9236 13.263 35.6693 13.1825 35.3432C13.0868 34.9553 12.915 34.6377 12.6669 34.3904C12.4167 34.1342 12.0025 33.8577 11.4243 33.5608C10.6944 33.1799 10.1583 32.8072 9.81595 32.4428C9.4714 32.0696 9.2328 31.6142 9.10014 31.0765C8.91963 30.345 8.96554 29.7352 9.23788 29.2472C9.50804 28.7504 9.99568 28.415 10.7008 28.241C11.3972 28.0692 11.9716 28.1426 12.4242 28.461C12.8835 28.7685 13.2055 29.2968 13.3904 30.046L13.485 30.4295L12.11 30.7687L11.9925 30.2928C11.9142 29.9755 11.796 29.7615 11.6378 29.6509C11.4774 29.5315 11.2782 29.5012 11.0403 29.5599C10.5555 29.6795 10.3859 30.0346 10.5317 30.6252C10.6143 30.9601 10.7796 31.2513 11.0277 31.4986C11.2846 31.7438 11.7021 32.0149 12.2803 32.3117C13.0189 32.6905 13.5561 33.0676 13.8919 33.4429C14.2276 33.8183 14.4672 34.2968 14.6108 34.8786C14.7978 35.6366 14.7518 36.2651 14.4729 36.764C14.2027 37.2608 13.7107 37.5973 12.9967 37.7735ZM15.1724 28.6806L13.652 29.0558L13.3258 27.7336L17.821 26.6245L18.1473 27.9466L16.6268 28.3218L18.5841 36.2546L17.1297 36.6134L15.1724 28.6806ZM22.8919 35.332C22.1779 35.5082 21.5814 35.4403 21.1024 35.1283C20.6233 34.8164 20.2924 34.2902 20.1098 33.5498L18.9093 28.6844C18.7266 27.944 18.7747 27.3243 19.0537 26.8253C19.3327 26.3263 19.8292 25.9888 20.5431 25.8126C21.2571 25.6364 21.8536 25.7043 22.3326 26.0163C22.8117 26.3282 23.1425 26.8544 23.3252 27.5948L24.5257 32.4603C24.7084 33.2007 24.6602 33.8203 24.3813 34.3193C24.1023 34.8183 23.6058 35.1558 22.8919 35.332ZM22.5657 34.0099C23.0681 33.8859 23.2442 33.5198 23.0942 32.9116L21.848 27.8611C21.698 27.2529 21.3717 27.0108 20.8693 27.1347C20.3669 27.2587 20.1907 27.6248 20.3408 28.233L21.5869 33.2835C21.737 33.8917 22.0632 34.1338 22.5657 34.0099ZM28.1327 34.0389C27.4364 34.2107 26.8542 34.144 26.3861 33.8387C25.9269 33.5312 25.6081 33.0161 25.4297 32.2933L24.2032 27.3221C24.0248 26.5993 24.0674 25.995 24.3309 25.5092C24.6033 25.0212 25.0876 24.6913 25.7839 24.5195C26.4803 24.3477 27.0581 24.4155 27.5173 24.723C27.9854 25.0283 28.3086 25.5424 28.4869 26.2651L28.7283 27.2435L27.3533 27.5828L27.089 26.5118C26.9477 25.9389 26.6346 25.7123 26.1498 25.8319C25.665 25.9515 25.4933 26.2977 25.6347 26.8707L26.9102 32.0402C27.0494 32.6043 27.3614 32.8266 27.8461 32.707C28.3309 32.5874 28.5037 32.2455 28.3645 31.6814L28.0155 30.2667L29.3905 29.9274L29.7135 31.2364C29.8918 31.9591 29.8448 32.5645 29.5725 33.0525C29.3089 33.5383 28.829 33.8671 28.1327 34.0389ZM28.8286 23.9086L30.2829 23.5497L31.2452 27.45L32.1339 23.093L33.5883 22.7342L32.6946 26.5594L35.8982 31.9826L34.3778 32.3578L32.1304 28.5361L31.839 29.8563L32.5664 32.8047L31.1121 33.1635L28.8286 23.9086Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.92572,
    y1: 14.7912,
    x2: 33.4176,
    y2: 8.69058,
    stroke: "white",
    strokeWidth: 0.638338
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.9052,
    y1: 39.6896,
    x2: 36.3971,
    y2: 33.589,
    stroke: "white",
    strokeWidth: 0.638338
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_14796_16208",
    x: 0,
    y: 0,
    width: 44,
    height: 70.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14796_16208"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_14796_16208",
    result: "effect2_dropShadow_14796_16208"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_14796_16208",
    result: "effect3_dropShadow_14796_16208"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_14796_16208",
    result: "effect4_dropShadow_14796_16208"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_14796_16208",
    result: "effect5_dropShadow_14796_16208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_14796_16208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14796_16208",
    x1: 22,
    y1: 1,
    x2: 22,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5D9D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyStocknew);
export default __webpack_public_path__ + "static/media/ReadyStocknew.34e74f4ccead61e1e8ce1d523dbd44bb.svg";
export { ForwardRef as ReactComponent };